<template>
    <div>
        <vue-final-modal :z-index="100000" v-model="showModal" classes="modal-container" content-class="modal-content">
            <a class="modal__close" @click="closeModal">
                <i class="fas fa-times"></i>
            </a>
            <span class="modal__title">Labels</span>
            <div class=" modal__content">
                <Multiselect
                    mode="tags"
                    :closeOnSelect="false"
                    :searchable="true"
                    :createTag="true"
                    placeholder="Wähle Label"
                    noOptionsText="Keine Labels vorhanden"
                    noResultsText="Kein Label gefunden"

                    :filterResults="false"
                    :minChars="1"
                    :resolveOnLoad="false"
                    :delay="0"

                    v-model="value"
                    :options="async function(query) {
    return await fetchLabels(query) // check JS block in JSFiddle for implementation
  }"
                >
                    <template v-slot:tag="{ option, handleTagRemove, disabled }">
                        <div class="multiselect-tag " v-bind:class="option.color">
                            {{ option.label }}
                            <span
                                v-if="!disabled"
                                class="multiselect-tag-remove"
                                @mousedown.prevent="handleTagRemove(option, $event)"
                            >
            <span class="multiselect-tag-remove-icon"></span>
          </span>
                        </div>
                    </template>
                </Multiselect>
                <p class="text-muted">Tipp für neues Label: Neues Wort + ENTER-Taste</p>
                <div v-if="error" class="alert alert-info" role="alert">
                    {{error}}
                </div>
            </div>

            <div class="modal__action">
                <a href="#" class="btn btn-outline-secondary" @click="closeModal">Abbrechen</a>
                <a href="#" class="btn btn-success" @click="save">Speichern</a>

            </div>
        </vue-final-modal>

    </div>
</template>

<script>
import Multiselect from '@vueform/multiselect'
export default {

    components: {
        Multiselect,
    },
    methods:{
        closeModal() {
           this.showModal=false
           this.value=null
        },
        save() {
            axios.post('/api/submission/'+this.submissionId+'/labels', {
                labels: this.value,
            })
                .then((resp)=> {
                    this.closeModal()
                })
                .catch( (error)=> {
                    error="Leider konnten die Labels nicht gespeichert werden."
                });
        },
        async fetchLabels(query) {
            // From: https://www.back4app.com/database/paul-datasets/list-of-all-programming-languages/get-started/javascript/rest-api/fetch?objectClassSlug=dataset

            const response = await axios.get(
                '/api/'+this.competitionId+'/labels'

            );
            return response.data.map((item) => {
                return { value: item.id, label: item.name, color:'bg-'+item.color }
            })
        }
    }
    ,
    data: () => ({
        showModal: false,
        value: null,
        error: null,
        submissionId:null,
        competitionId:null,
        options: [
        ]
    }),
}
</script>

<style scoped>
::v-deep .modal-container {
    display: flex;
    justify-content: center;
    align-items: center;
}
::v-deep .modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: 250px;
    max-height: 90%;
    max-width: 500px;
    margin: 0 1rem;
    padding: 1rem;
    border: 1px solid #e2e8f0;
    border-radius: 0.25rem;
    background: #fff;
}
.modal__title {
    margin: 0 2rem 0 0;
    font-size: 1.5rem;
    font-weight: 700;
}
.modal__content {
    flex-grow: 1;
    overflow-y: auto;
}
.modal__action {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-shrink: 0;
    padding: 1rem 0 0;
}
.modal__close {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
}
</style>

<style scoped>
.dark-mode div::v-deep .modal-content {
    border-color: #2d3748;
    background-color: #1a202c;
}
</style>
<style src="@vueform/multiselect/themes/default.css"></style>
